import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-table-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (header, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "px-table-header__item"
      }, [
        _createElementVNode("p", null, _toDisplayString(header.title), 1),
        (header.tooltip)
          ? (_openBlock(), _createBlock(_component_ElTooltip, {
              key: 0,
              content: header.tooltip,
              placement: "top",
              "popper-class": "px-table-header__tooltip el-abaca-tooltip"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "icon icon-question" }, null, -1)
              ]))]),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}